<script lang="ts" setup>
/*
  See MNTX-859 why we handle "Webshop" stock in a different way
*/
import { useProductPageStore } from "~/stores/main";

// -----------------------
// composables
// -----------------------
const productPageStore = useProductPageStore();
const { t } = useI18n();

// -----------------------
// props & emits
// -----------------------
withDefaults(
  defineProps<{
    show?: boolean;
  }>(),
  {
    show: true,
  },
);

// -----------------------
// computed properties
// -----------------------
const variantRef = computed(() => {
  if (productPageStore.size === null || productPageStore.color === null) {
    return null;
  }

  return productPageStore.masterProduct?.products.find(
    (variant: Record<any, any>) => {
      return (
        variant.product.product_meret_property === productPageStore.size &&
        variant.product.product_szin_property === productPageStore.color
      );
    },
  );
});

// -----------------------
// helper functions
// -----------------------
const getStockStatus = () => {
  const product = variantRef?.value?.product;
  if (!product) return "out_of_stock";

  const stockInStores = product?.product_keszlet_property;

  let stockTotal = 0;
  for (const aStock of stockInStores) {
    stockTotal += aStock.value;
  }

  if (stockTotal === 0) {
    return "out_of_stock";
  } else if (stockTotal === 1) {
    return "last_piece";
  } else {
    return "in_stock";
  }
};
</script>

<template>
  <div>
    <div v-if="productPageStore.masterProduct">
      <div class="flex justify-between mt-5 xl:mt-5.5">
        <h3 class="font-bold text-base lg:text-xl">
          {{ t("stock") }}
        </h3>
      </div>
      <div class="mt-4 xl:mt-[22px]">
        <div>
          <BaseButton
            type="plain"
            font-weight="normal"
            :title="t(getStockStatus('__webshop'))"
            :disabled="getStockStatus('__webshop') === 'out_of_stock'"
            class="!bg-brand-secondary shadow-base mr-2 mb-2 min-w-[95px] min-h-[37px] xl:min-h-[44px] cursor-default text-sm"
          >
            <i
              class="ml-[6px] text-xs"
              :class="{
                'text-brand-secondary': getStockStatus() === 'in_stock',
                'm-icon-warning': getStockStatus() === 'last_piece',
                'm-icon-out_of_stock': getStockStatus() === 'out_of_stock',
              }"
            ></i>
            {{ t("product_page.one_stock_button") }}
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>
